<script>
import formatDate from '@utils/format-date'
import appConfig from '@src/app.config'
import Layout from '@layouts/main'
import { BOverlay } from 'bootstrap-vue'
import { Quill } from 'vue-quill-editor'
import { authComputed, courseListMethod } from '@state/helpers'
var Link = Quill.import('formats/link')
var builtInFunc = Link.sanitize
Link.sanitize = function customSanitizeLinkInput(linkValueInput) {
  var val = linkValueInput

  // do nothing, since this implies user's already using a custom protocol
  if (/^\w+:/.test(val));
  else if (!/^https?:/.test(val)) val = 'http://' + val

  return builtInFunc.call(this, val) // retain the built-in logic
}
export default {
  page: {
    title: 'Course Detail',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: {
    Layout,
    'b-overlay': BOverlay,
  },
  data() {
    return {
      show: false,
      courseId: '',
      // subCategoryList: []
      display: [
        { key: 'name', label: 'Name', colType: 'default' },
        { key: 'features', label: 'Features', colType: 'list' },
        { key: 'topics', label: 'Topics', colType: 'list' },
        { key: 'description', label: 'Description', colType: 'html' },
        { key: 'overview', label: 'Overview', colType: 'html' },
        {
          key: 'career_opportunity',
          label: 'Career Opportunity',
          colType: 'html',
        },
        { key: 'career_salary', label: 'Career Salary', colType: 'html' },
        { key: 'rating', label: 'Rating', colType: 'default' },
        { key: 'duration', label: 'Duration', colType: 'default' },
        { key: 'createdAt', label: 'Published On ', colType: 'date' },
      ],
      data: {},
      courseBatchExist: false,
      addedBy: '',
    }
  },
  computed: {
    ...authComputed,
    filteredItems() {
      return this.autocompleteItems.filter((i) => {
        return i.text.toLowerCase().indexOf(this.tag.toLowerCase()) !== -1
      })
    },
  },
  mounted() {
    this.getCourseInfo()
  },
  methods: {
    ...courseListMethod,
    getCourseInfo() {
      let Data = {}
      Data.id = this.$route.params.courseId
      this.getCourse({ Data }).then((data) => {
        this.addedBy = data.added_by
        const courseId = this.$route.params.courseId
        const filter = {
          course_id: courseId,
        }
        this.fetchCourseById({ courseId }).then((courseInfo) => {
          this.data = courseInfo
        })
        this.fetchCourseBatchList({ filter }).then((list) => {
          if (list.length >= 1) {
            this.courseBatchExist = true
          }
        })
      })
    },
    formatDates(date) {
      return formatDate(date)
    },
    handleRoute(path) {
      this.$router.push({ path: path })
    },
  },
}
</script>

<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-overlay :show="show" :opacity="0.6" rounded="sm">
          <b-card>
            <button
              v-if="
                role !== 'hod' &&
                  role !== 'teacher' &&
                  !courseBatchExist &&
                  addedBy === currentUser.user._id
              "
              id="show-modal"
              class="btn btn-info"
              @click="
                handleRoute(`/add-course-batch/${$route.params.courseId}`)
              "
              ><i class="ti-plus"></i>Add Course Batch</button
            >&nbsp;
            <button
              v-if="
                role !== 'hod' &&
                  role !== 'teacher' &&
                  courseBatchExist &&
                  addedBy === currentUser.user._id
              "
              id="show-modal"
              class="btn btn-info"
              @click="
                handleRoute(`/add-course-content/${$route.params.courseId}`)
              "
              ><i class="ti-plus"></i>Add Course Session</button
            >
            <br /><br />
            <table
              class="table table-bordered table-inverse table-responsive-lg"
            >
              <tbody>
                <tr v-for="(item, index) in display" :key="index">
                  <td
                    v-if="
                      data[item.key] ||
                        item.label === 'Blocked' ||
                        item.label === 'Locked' ||
                        item.label === 'Login Status' ||
                        item.label === 'Registration Status' ||
                        item.label === 'Added On' ||
                        item.label === 'Email Sent'
                    "
                  >
                    <strong>{{ item.label }}</strong>
                  </td>
                  <td v-if="item.label === 'Name'">
                    <div>{{ data[item.key] }}</div>
                  </td>
                  <td v-else-if="item.label === 'Course Assigned'">
                    <div
                      v-for="(item1, index1) in data[item.key]"
                      :key="`list${index1}`"
                    >
                      <p>{{ item1.name }}</p>
                    </div>
                  </td>
                  <td v-else-if="item.label === 'Assigned Students'">
                    <div
                      v-for="(item1, index1) in data[item.key]"
                      :key="`list${index1}`"
                    >
                      <p>{{ item1.name }}</p>
                    </div>
                  </td>
                  <td v-else-if="item.key === 'teacher_id'">
                    <div
                      v-for="(item1, index1) in data[item.key]"
                      :key="`list${index1}`"
                    >
                      <p>{{ item1.name }}</p>
                    </div>
                  </td>
                  <td v-else-if="item.label === 'Assigned Batches'">
                    <div
                      v-for="(item1, index1) in data[item.key]"
                      :key="`list${index1}`"
                    >
                      <p v-if="item1.name !== undefined">{{ item1.name }}</p>
                      <p v-else>{{ item1 }}</p>
                    </div>
                  </td>
                  <td
                    v-else-if="
                      item.label === 'Document(s)' &&
                        data[item.key] !== undefined &&
                        data[item.key].length !== '0'
                    "
                  >
                    <div
                      v-for="(item1, index1) in data[item.key]"
                      :key="`list${index1}`"
                    >
                      <p>{{ item1 }}</p>
                    </div>
                  </td>
                  <td
                    v-else-if="
                      item.label === 'Video(s)' &&
                        data[item.key] !== undefined &&
                        data[item.key].length !== '0'
                    "
                  >
                    <div
                      v-for="(item1, index1) in data[item.key]"
                      :key="`list${index1}`"
                    >
                      <p>{{ item1.title }}</p>
                    </div>
                  </td>
                  <td v-else-if="item.label === 'Assigned By'">
                    {{ data[item.key].email }}
                  </td>
                  <td v-else-if="item.label === 'Added By'">
                    {{ data[item.key].email }}
                  </td>
                  <td
                    v-else-if="
                      item.label === 'Submission Deadline' &&
                        data[item.key] !== undefined
                    "
                  >
                    {{ formatDates(data[item.key]) }}
                  </td>
                  <td v-else-if="item.label === 'Category'">
                    <div>{{ data['category'].name }}</div>
                  </td>
                  <td v-else-if="item.colType === 'html'">
                    <div v-html="data[item.key]"></div>
                  </td>
                  <td v-else-if="item.colType === 'list'">
                    <ul style="margin-left:10px;">
                      <li
                        v-for="(item1, index1) in data[item.key]"
                        :key="`list${index1}`"
                        >{{ item1 }}</li
                      >
                    </ul>
                  </td>
                  <td v-else-if="item.colType === 'list'">
                    <ul>
                      <li
                        v-for="(item1, index1) in data[item.key]"
                        :key="`list${index1}`"
                        >{{ item1 }}</li
                      >
                    </ul>
                  </td>
                  <td v-else-if="item.label === 'Registration Status'">
                    <b-badge v-if="data[item.key] === true" variant="success"
                      >Done</b-badge
                    >
                    <b-badge v-else variant="danger">Pending</b-badge>
                  </td>
                  <td v-else-if="item.key === 'emailStatus'">
                    <b-badge v-if="data[item.key] === true" variant="success"
                      >Yes</b-badge
                    ><p v-else>
                      <b-badge variant="danger">No</b-badge>
                      <b-button class="mailbutton" @click="sendemail(data)"
                        >Send Mail</b-button
                      >
                      <br /><br /><b-alert
                        v-model="isSuccess"
                        variant="success"
                        v-html="successMessage"
                      ></b-alert>
                    </p>
                  </td>
                  <td v-else-if="item.key === 'loginStatus'">
                    <b-badge v-if="data[item.key] === true" variant="success"
                      >Active</b-badge
                    >
                    <b-badge v-else variant="danger">Inactive</b-badge>
                  </td>
                  <td v-else-if="item.label === 'Blocked'">
                    <b-badge v-if="data[item.key] === 'spam'" variant="danger"
                      >Yes</b-badge
                    >
                    <b-badge v-else variant="success">No</b-badge>
                  </td>
                  <td v-else-if="item.label === 'Locked'">
                    <b-badge
                      v-if="new Date(data[item.key]) > new Date()"
                      variant="danger"
                      >Yes</b-badge
                    >
                    <b-badge v-else variant="success">No</b-badge>
                  </td>
                  <td v-else-if="item.colType === 'badge'">
                    <b-badge
                      :variant="
                        data[item.key] === 'active' || data[item.key] === true
                          ? 'success'
                          : 'danger'
                      "
                      >{{ data[item.key] }}</b-badge
                    >
                  </td>
                  <td
                    v-else-if="
                      item.colType === 'date' &&
                        item.label !== 'Submission Deadline'
                    "
                  >
                    {{ formatDates(data[item.key]) }}
                  </td>
                  <td v-else-if="data[item.key]">{{ data[item.key] }}</td>
                </tr>
              </tbody>
            </table>
          </b-card>
        </b-overlay>
      </div>
    </div>
  </Layout>
</template>
<style>
.cancel {
  background-color: grey;
}
.cancel:hover {
  background-color: grey !important;
}
.cancel:active {
  background-color: grey !important;
}

.cancel-anchor {
  color: white !important;
}
.cancel-anchor:hover {
  color: white;
}
.vue-tags-input {
  max-width: 100% !important;
}
.showError {
  color: red;
}
.ti-new-tag-input-wrapper input {
  font-family: 'Roboto', sans-serif;
  font-size: 0.9rem;
  font-weight: 400;
}
.ti-tag::before {
  display: none;
}
[class^='ti-'],
[class*=' ti-'] {
  /* font-family: inherit; */
  font-size: inherit !important;
  font-weight: inherit !important;
}
</style>
